import { AssistantModalPrimitive } from '@assistant-ui/react';
import { faMessage } from '@fortawesome/duotone-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type FC } from 'react';
import { type Avatar, Thread } from '../thread';
import { WelcomeConfig } from '../thread/WelcomeConfig';
import './AssistantModal.scss';

interface Props {
  readonly avatar: Avatar;
  readonly welcome: WelcomeConfig;
}

export const AssistantModal: FC<Props> = ({ avatar, welcome }) => {
  return (
    <AssistantModalPrimitive.Root>
      <AssistantModalPrimitive.Trigger asChild>
        <button className={'button is-primary is-large is-rounded'}>
          <span className={'icon'}>
            <FontAwesomeIcon icon={faMessage} />
          </span>
        </button>
      </AssistantModalPrimitive.Trigger>
      <AssistantModalPrimitive.Content side={'right'} align={'center'} className={'modal-chat'}>
        <div className={'modal-chat-container box'}>
          <Thread avatar={avatar} welcome={welcome} />
        </div>
      </AssistantModalPrimitive.Content>
    </AssistantModalPrimitive.Root>
  );
};
AssistantModal.displayName = 'AssistantModal';
